var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"image-modal",attrs:{"id":_vm.modalId},on:{"click":_vm.closeModal}},[_c('div',{staticClass:"modal-image-wrapper"},[_c('span',{staticClass:"close",on:{"click":_vm.closeModal}},[_vm._v("×")]),_c('img',{staticClass:"image-modal-content",attrs:{"src":_vm.getImgUrl(_vm.imageName)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }